import React from 'react';

/**
 * Generic empty-state card used by every module.
 *
 * Props:
 *   icon          – emoji or JSX (e.g. "💰" or <WalletIcon />)
 *   title         – heading text
 *   description   – body text
 *   actionLabel   – primary button label
 *   onAction      – primary button handler
 *   secondaryLabel – optional secondary button label
 *   onSecondary   – optional secondary button handler
 *   className     – optional extra wrapper classes
 */
export default function EmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  onSecondary,
  className = '',
}) {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-6 text-center ${className}`}>
      {/* Icon */}
      <div className="w-16 h-16 bg-slate-800 border border-slate-700 rounded-2xl flex items-center justify-center mb-5 text-3xl select-none">
        {icon}
      </div>

      <h3 className="text-lg font-semibold text-slate-200 mb-2">{title}</h3>

      <p className="text-sm text-slate-400 max-w-xs leading-relaxed mb-6">
        {description}
      </p>

      <div className="flex items-center gap-3 flex-wrap justify-center">
        {onAction && (
          <button
            onClick={onAction}
            className="px-5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold rounded-lg transition-colors shadow-lg shadow-blue-900/30"
          >
            {actionLabel}
          </button>
        )}
        {onSecondary && (
          <button
            onClick={onSecondary}
            className="px-5 py-2.5 bg-slate-800 border border-slate-700 hover:bg-slate-700 text-slate-300 text-sm font-medium rounded-lg transition-colors"
          >
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  );
}
